<template>
  <v-layout row>
    <v-flex xs6 sm6 md3 lg3 xl3 px-1 py-1>
      <label class="cmr-book-form-label">Date</label>
        <div>
            <BookingDateInput
                @input="function() {bookingForm.updateDate(); lastTime = null;}"
                v-model="bookingForm.booking.pickup_date"
                :error="bookingForm.errors.pickup_time"
            />
        </div>
    </v-flex>
    <v-flex xs5 sm6 md4 lg4 xl3 py-1 px-1 pr-1 grow>
      <label class="cmr-book-form-label mrc-blue-ribbon">Time &nbsp;<b v-if="driverETA">Arrive: {{ driverETA }}</b></label>
      <SimpleTextInput
        @blur="function() {bookingForm.updateDate(); lastTime = null;}"
        v-mask="mask"
        v-model="bookingForm.booking.pickup_time"
      ></SimpleTextInput>
    </v-flex>
    <v-flex xs12 sm12 md5 lg5 xl6  v-if="!hideAsapToggle" align-self-center class="mt-5">
      <v-btn-toggle dense color="primary" class="" style="width: 25px">
        <v-btn height="30" width="26px" x-small @click="function() {bookingForm.toggleAsap(); lastTime = 0;}">
          Now
        </v-btn>

        <v-btn height="30" x-small @click="function() {bookingForm.setPickupTimeAhead(15); lastTime = 15;}">
          15
        </v-btn>
        <v-btn height="30" x-small @click="function() {bookingForm.setPickupTimeAhead(30); lastTime = 30;}">
          30
        </v-btn>
        <v-btn height="30" x-small @click="function() {bookingForm.setPickupTimeAhead(60); lastTime = 60;}">
          1H
        </v-btn>
      </v-btn-toggle>
    </v-flex>
  </v-layout>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import { Overwatch } from "@/components/util/Overwatch.js";


import { mask } from "vue-the-mask";
import moment from 'moment'

export default {
  name: "BookingDateTimeInputV2",
  directives: {
    mask
  },
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingDateInput,
    SimpleTextInput
  },
  props: {
    driverETA: String,
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAsapToggle: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "bookingForm.currentlyShowing" () {
      console.log('current driver eta')
      this.driverETA = this.pickupTimeETA
    }
  },
  computed: {
    pickupTimeETA: function() {

      if (this.bookingForm.currentlyShowing) {
        var put = this.bookingForm.booking.pickup_datetime;

        if (put == null) {
          put = new Date();
        }

        return moment(put).add(this.bookingForm.currentlyShowing.minutes_from_pickup, "minutes").format("HH:mm");
      }
      return null
    },
    arriveByTime: function () {
      if (this.bookingForm.booking.route.time == null) {
        return "";
      }

      return this.calculateArriveByTime(
          this.bookingForm.booking.route.time
      );
    },
  },
  data() {
    return {
      mask: "##:##",
      menu: false,
      lastTime: null,
      driverEstimatedTimeOfArrival: null
    };
  },
  methods: {
    calculateArriveByTime: function (minutes) {
      if (this.bookingForm.booking.pickup_time && minutes) {
        return moment(this.bookingForm.booking.pickup_time, 'HH:mm').add(minutes, 'm').format("HH:mm")
      }
      return null
    },
    colorForAsapButton: function() {
      console.log("Booking form asap " + this.bookingForm.booking.asap);
      return {
        backgroundColor: this.bookingForm.booking.asap
          ? "lightgreen"
          : "lightgrey"
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.now-toggle {
  cursor: pointer;
  padding-left: 6px;
  padding-right: 6px;
  height: 24px;
  width: 36px;
  font-size: 11px;
  text-align: center;
}

.future-toggle {
  cursor: pointer;
  background-color: lightgray;
  padding-left: 6px;
  padding-right: 6px;
  height: 24px;
  width: 26px;
  font-size: 11px;
  text-align: center;
}

.left {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.right {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.centered-p {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.dense {
  font-size: 8pxx ;
}
</style>
